// extracted by mini-css-extract-plugin
module.exports = {"headline":"lqgCFC","withSubtotalTitle":"L8Lh1x","oldHeadline":"Fk6N6L","totals":"uzbgvO","line":"VichYS","divider":"sRIWuY"};